import { createSlice } from '@reduxjs/toolkit';
import { IPageData } from '../pages/AgencyManagement/interface';
import { Agency, AgencyTypeOptions } from '../pages/AgencyManagement/interfaces/types';
import { IAgencyRankingData } from '../components/AgencyPerformanceBanner/interfaces';

const initialState = {
  allAgencyData: [],
  allAgencyPage: {} as IPageData,
  isLoading: true,
  agencyRefId: '',
  states: [],
  showLoader: false,
  agencyData: {} as Agency,
  agencyTypesData: [] as AgencyTypeOptions[],
  agencyTypeMappings: {} as Record<string, AgencyTypeOptions>,
  isModalOpen: false,
  isTerminateAgencyOptionSelected: false,
  agencyRankingData: {} as IAgencyRankingData
};

const agencyDetailsSlice = createSlice({
  name: 'agencySlice',
  initialState,
  reducers: {
    setAllAgencyData(state, action) {
      const { data, pages } = action.payload;
      state.allAgencyData = data;
      state.allAgencyPage = pages;
    },
    setAllAgencyApiCalling(state, action) {
      state.isLoading = action.payload;
    },
    setAgencyRefId(state, action) {
      state.agencyRefId = action.payload;
    },
    setStates(state, action) {
      const { data } = action.payload;
      state.states = data;
    },
    setShowLoader(state, action) {
      state.showLoader = action.payload;
    },
    setAgencyData(state, action) {
      state.agencyData = action.payload;
    },
    setAgencyTypesData(state, action) {
      state.agencyTypesData = action.payload;
    },
    setAgencyTypeMappings(state, action) {
      state.agencyTypeMappings = action.payload;
    },
    setIsModalOpen(state, action) {
      state.isModalOpen = action.payload;
    },
    setIsTerminateAgencyOptionSelected(state, action) {
      state.isTerminateAgencyOptionSelected = action.payload;
    },
    setAgencyRankingData(state, action) {
      state.agencyRankingData = action.payload;
    }
  }
});

export const {
  setAllAgencyData,
  setAllAgencyApiCalling,
  setAgencyRefId,
  setStates,
  setShowLoader,
  setAgencyData,
  setAgencyTypesData,
  setIsModalOpen,
  setIsTerminateAgencyOptionSelected,
  setAgencyRankingData,
  setAgencyTypeMappings
} = agencyDetailsSlice.actions;

export default agencyDetailsSlice.reducer;
